import BaseTable from '@base/features/game/model/baseTable';
import { t } from '@base/utils/helpers';

class Table extends BaseTable {
  getGameTypeString() {
    const gameTypeStr = '';
    return gameTypeStr;
  }

  getGameTypeStringLong() {
    const gameTypeStr = '';
    return gameTypeStr;
  }

  getMatchString() {
    let res = '';
    res += this.maxPoints.toString();
    res += 'pt';
    if (this.minPoints === -1 && this.maxPoints !== -1) {
      res += '/Cr';
    } else if (this.minPoints === 0) {
      res += '/noDbl';
    }
    if (this.inviteOnly) {
      res += ' X';
    }
    if (!this.ratingGame) {
      res += '-R';
    }
    return res;
  }

  getMaxPointsString() {
    return this.getMatchString();
  }

  getMatchStringLong() {
    const prefix = '';
    // TODO screen size
    // if (Main.screenSize === Main.screen.size.desktop) prefix = t('match_');

    let res = '';
    res += this.maxPoints.toString();
    res += 'pt';
    if (this.minPoints === -1 && this.maxPoints !== -1) {
      res += '\nCrawford';
    } else if (this.minPoints === 0) {
      res += '\nNo double';
    }
    if (this.inviteOnly) {
      res += '\nInvitation-only game';
    }
    if (!this.ratingGame) {
      res += '\nNon-rated game';
    }

    return prefix + res;
  }

  getTicketString() {
    const cost = this.getCost();
    if (cost > 0) {
      if (cost === 1) {
        return '1/2';
      } else {
        return (cost / 2).toString();
      }
    }
    return '';
  }

  getTicketsStringLong() {
    const cost = this.getCost();
    if (cost > 0) {
      return this.getTicketString() + t('_tickets');
    }
    return '';
  }
}

export default Table;
